var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$parent.showFlag)?_c('div',{ref:"dataNum",staticClass:"base-swiper-item",style:({
  width:_vm.$parent.offsetWidth+'px',
  transform:("translateX(" + _vm.offsetWidth + "px)"),
  'z-index':_vm.zIndex
})},[_vm._t("default")],2):_c('div',{staticClass:"base-swiper-item",style:({
  width:_vm.$parent.offsetWidth+'px',
  transform:("translateX(" + _vm.offsetWidth + "px)"),
  transition:("transform " + _vm.delay + "ms"),
  'z-index':_vm.zIndex
})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2a8db9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base-swiper-item.vue
// module id = null
// module chunks = 